<template>
  <div
    class="modal fade show"
    style="display: block">
    <div class="modal-dialog ">
      <div class="modal-content">
        <div class="modal-header">Crop Image</div>
        <div class="modal-body">
          <div :style="getCropperParentStyle">
            <cropper
              ref="cropper"
              :src="getSrc"
              :default-position="{top:getStencilDefaultPositionTop,left:getStencilDefaultPositionLeft}"
              :default-size="{width:getWidth,height:getHeight}"
              :stencil-props="getAspectRatio"
              :stencil-component="(circleCrop) ? $options.components.CircleStencil : $options.components.RectangleStencil "
              class="cropper"
            />
          </div>
        </div>
        <div class="modal-footer crop-modal-footer justify-content-between">
          <div
            class="d-flex align-items-center justify-content-center aspect-ratio"
            @click.stop="lockAspectRatio()">
            <span
              v-if="aspectRatioLock || circleCrop"
              class="lock-icon"><i class="fa fa-lock"/></span>
            <span
              v-else
              class="unlock-icon"><i class="fa fa-unlock"/></span>
            <div class="aspect-ratio-title">{{ (aspectRatioLock || circleCrop) ? 'Unlock' : 'Lock' }} Aspect Ratio</div>
          </div>
          <ul class="d-flex list-unstyled panel-buttons mb-0">
            <li class="me-12 position-relative">
              <button
                v-tooltip="'Circle Crop'"
                id="28"
                :class="circleCrop ? 'selected' : ''"
                class="lf-btn btn-lightest-gray bm-bordered-btn position-relative shadowed-btn"
                @click.stop="enableCrop('circle')">
                <icon name="circle"/>
              </button>
            </li>

            <li class="me-12 position-relative">
              <button
                v-tooltip="'Add Rectangle'"
                id="29"
                :class="circleCrop ? '' : 'selected'"
                class="lf-btn btn-lightest-gray bm-bordered-btn position-relative shadowed-btn"
                @click.stop="enableCrop('rectangle')">
                <icon name="rectangle"/>
              </button>
            </li>


          </ul>

          <div >
            <button
              class="btn btn-secondary"
              @click="cancelCropping">Cancel
            </button>
            <button
              class="btn btn-primary"
              @click="cropImage">Crop
            </button>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
import { CircleStencil, Cropper, RectangleStencil } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import EventBus from '@/EventBus';

export default {
  components: { Cropper, CircleStencil, RectangleStencil },
  data() {
    return { aspectRatioLock: true, circleCrop: this.$store.getters.getCrop.object.circleCrop };
  },
  computed: {

    getAspectRatio() {
      const width  = this.getSelectedObject.Width;
      const height = this.getSelectedObject.Height;
      if (this.aspectRatioLock) {
        const params = { aspectRatio: width / height };
        console.log(params);
        return { aspectRatio: width / height };
      }
      return {};
    },
    getCropperParentStyle() {
      const elem = document.getElementById('canvas-section');
      let scale  = 1;
      if (this.getSelectedObject.Height > this.getSelectedObject.Width) {
        const containerHeight = Math.min(elem.offsetHeight, 500);
        scale                 = containerHeight / this.getSelectedObject.Height;
      } else {
        const containerWidth = Math.min(elem.offsetWidth, 700);
        if (containerWidth < this.getSelectedObject.Width) { scale = containerWidth / elem.offsetWidth; }
      }
      return '';
    },
    getSelectedObject() {
      return this.$store.getters.getCrop.object;
    },
    getSrc() {
      return this.getSelectedObject.DefaultImageUrl;
    },
    getWidth() {
      return this.getSelectedObject.Width;
    },
    getStencilWidth() {
      return parseInt(this.getWidth * this.getStencilScale);
    },
    getStencilHeight() {
      return parseInt(this.getHeight * this.getStencilScale);
    },
    getStencilScale() {
      return this.getSelectedObject.stencilScale;
    },
    getHeight() {
      return this.getSelectedObject.Height;
    },
    getStencilDefaultPositionTop() {
      return this.getSelectedObject.stencilDefaultPositionTop;
    },
    getStencilDefaultPositionLeft() {
      return this.getSelectedObject.stencilDefaultPositionLeft;
    },
  },
  mounted() {
    console.log('zooming cropper');
    // this.$refs.cropper.zoom(50);
  },
  methods: {
    enableCrop(type) {
      if (type == 'circle') {
        this.circleCrop = true;
      } else {
        this.circleCrop = false;
      }
    },

    lockAspectRatio() {
      if (this.aspectRatioLock) {
        this.aspectRatioLock = false;
      } else {
        this.aspectRatioLock = true;
      }
    },
    cropImage() {
      const result                     = this.$refs.cropper.getResult();
      const coordinates                = result.coordinates;
      const stencilDefaultPositionTop  = coordinates.top;
      const stencilDefaultPositionLeft = coordinates.left;
      // calculation for high resourse image

      let HeightRatio,
        WidthRatio,
        HighResWidth,
        HighResHeight,
        HighResTop,
        HighResLeft;
      if (this.getSelectedObject.HighResV2Height && this.getSelectedObject.HighResV2Width) {
        if ((this.getSelectedObject.HighResV2Height < parseInt(this.getSelectedObject.DefaultImageHeight)) && (this.getSelectedObject.HighResV2Width < parseInt(this.getSelectedObject.DefaultImageWidth))) {
          HeightRatio   = parseFloat(this.getSelectedObject.DefaultImageHeight) / parseFloat(this.getSelectedObject.HighResV2Height);
          WidthRatio    = parseFloat(this.getSelectedObject.DefaultImageWidth) / parseFloat(this.getSelectedObject.HighResV2Width);
          HighResWidth  = Math.abs(coordinates.width / WidthRatio);
          HighResHeight = Math.abs(coordinates.height / WidthRatio);
          HighResTop    = Math.abs(coordinates.top / HeightRatio);
          HighResLeft   = Math.abs(coordinates.left / WidthRatio);
        } else {
          HeightRatio   = parseFloat(this.getSelectedObject.HighResV2Height) / parseFloat(this.getSelectedObject.DefaultImageHeight);
          WidthRatio    = parseFloat(this.getSelectedObject.HighResV2Width) / parseFloat(this.getSelectedObject.DefaultImageWidth);
          HighResWidth  = WidthRatio * coordinates.width;
          HighResHeight =  HeightRatio * coordinates.height;
          HighResTop    = HeightRatio * coordinates.top;
          HighResLeft   = WidthRatio * coordinates.left;
        }
      } else {
        HighResWidth  = coordinates.width;
        HighResHeight = coordinates.height;
        HighResTop    = coordinates.top;
        HighResLeft   = coordinates.left;
      }


      let scale = 1;
      scale     = (parseInt(result.image.width) * parseFloat(result.image.transforms.scaleX)) / this.getWidth;
      // let stencilScale=result.image.transforms.scaleX
      const stencilScale       = scale;
      const croppedSrc         = `https://pdf-processing.bankmarketingcenter.com/node/image?width=${coordinates.width}&height=${coordinates.height}&top=${coordinates.top}&left=${coordinates.left}&src=${this.getSelectedObject.DefaultImageUrl}`;
      const croppedHighResPath =
          this.getSelectedObject.isBackgroundRemoved
              ? croppedSrc
              : `https://pdf-processing.bankmarketingcenter.com/node/image?width=${HighResWidth}&height=${HighResHeight}&top=${HighResTop}&left=${HighResLeft}&src=${this.getSelectedObject.HighResPath}`;


      const data               = {
        stencilDefaultPositionTop,
        stencilDefaultPositionLeft,
        croppedSrc,
        stencilScale,
        tempIndex:  document.getElementById(this.getSelectedObject.Id).dataset.elementindex,
        croppedHighResPath,
        circleCrop: this.circleCrop,
        Width:      this.getSelectedObject.Width,
        Height:     (this.circleCrop) ? this.getSelectedObject.Width : this.getSelectedObject.Height,
      };
      EventBus.$emit('updateObjectAfterCrop', data);
      this.cancelCropping();
    },
    cancelCropping() {
      this.$store.commit('updateCrop', { isEnable: false, object: null });
    },
  },
};
</script>

<style lang="scss">
.modal{
  background-color: rgba(0,0,0,0.6);
}
.crop-modal-footer{
  font-family: 'Open Sans';
  .aspect-ratio{
    cursor: pointer;
    font-size: 18px;
    color:#3f3f3f;
    .aspect-ratio-title{
      font-size: 13px;
    }
    .lock-icon,  {
      color: #3bb0fa;
      margin: 0px  5px;
    }
    .unlock-icon{
      margin: 0px  5px;
    }
  }
  .btn{
    margin: 0px 5px;
    font-size: 13px;
    &.btn-primary{
      background-color: #3bb0fa !important;
      border-color: #3bb0fa !important
    }
  }
}

.cropper {
  max-width: 800px;
  max-height: 500px;
}

.modal {
  z-index: 106000 !important;

  .modal-dialog {
    max-width: 800px;
  }
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
  background: #151515;
  cursor: pointer;
  transition: background 0.5s;
  border: none;

  &:not(:last-of-type) {
    margin-right: 10px;
  }

  &:hover {
    background: #2F2F2F;
  }

  input {
    display: none;
  }
}
</style>
